import Spinner from '@s-ui/react-atom-spinner'
import Layout from '@adv-mt/mt-layout-basic'

import LinkFactory from '../../../components/LinkFactory/index.js'

const MyAdsLoading = () => (
  <Layout.FullWidth footerProps={{isSimple: true}} linkFactory={LinkFactory}>
    <Spinner />
  </Layout.FullWidth>
)

MyAdsLoading.displayName = 'MyAdsLoading'

export default MyAdsLoading
